export const MAX_SEARCH_RESULTS_PER_CATEGORY = 5;
export const MAX_RECORDS_PER_CONTACT = 3;
export const SEARCH_TOOL_CACHE_WINDOW_MS = 120_000;
export const DASHBOARD_ASSISTANT_RUNTIME_MODE = 'live_browser';

// Module-level cache of recent search results, keyed by session + org + query.
// Persists across renders so the assistant can short-circuit duplicate searches
// within SEARCH_TOOL_CACHE_WINDOW_MS.
export const recentSearchToolResults = new Map();
